'use strict';
import { resolutionsConfig as defaultConfig } from './resolutionsConfig';
import { toolbox } from '../../bss-package-toolbox/js/toolbox.js';
import logger from '@main/externals/bss-package-logger/js/logger';
var _resolutionsConfig;
var _toolbox;
/**
 * Resolutions class
 */
var Resolutions = /** @class */ (function () {
    /**
     * BSSSliderComponent constructor sets resolutions configuration
     * @param {object} EventManager - EventManager object
     * @param {object} opts - resolutions configuration
     */
    function Resolutions(eventManager, opts) {
        if (eventManager === void 0) { eventManager = null; }
        if (opts === void 0) { opts = null; }
        if (opts !== null) {
            _resolutionsConfig = opts;
        }
        else {
            _resolutionsConfig = defaultConfig;
        }
        this._localCurrentDevice = this._getDeviceType();
        this._eventManager = eventManager;
        _toolbox = toolbox;
        _toolbox
            .$(window)
            .on('resize', _toolbox._.debounce(this._onResize.bind(this), 300));
        logger.info('Resolution = > constructor | Params: ', eventManager, opts);
    }
    /**
     * _onResize method run on resize, check if current device has changed, if its true publish event
     *
     */
    Resolutions.prototype._onResize = function () {
        logger.info('Resolution = > _onResize');
        var currentDevice = this._getDeviceType();
        if (currentDevice !== this._localCurrentDevice) {
            this._localCurrentDevice = currentDevice;
            logger.info('Resolution = > _onResize : bss-device-type-changed');
            this._eventManager.publish('bss-device-type-changed', 'bss-resolution');
        }
    };
    Object.defineProperty(Resolutions.prototype, "resolutionsConfig", {
        /**
         * resolutionsConfig _resolutionsConfig getter
         * @return {object} - resolutions configuration
         *
         */
        get: function () {
            return _resolutionsConfig;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * _getDeviceType constructor sets resolutions configuration
     * @private method
     * @return {string} - bootstrap base width interval name
     */
    Resolutions.prototype._getDeviceType = function () {
        logger.info('Resolution = > _getDeviceType');
        var width = window.innerWidth;
        if (width < _resolutionsConfig.smMin) {
            return 'xs';
        }
        else if (width >= _resolutionsConfig.smMin &&
            width < _resolutionsConfig.mdMin) {
            return 'sm';
        }
        else if (width >= _resolutionsConfig.mdMin &&
            width < _resolutionsConfig.lgMin) {
            return 'md';
        }
        else {
            return 'lg';
        }
    };
    /**
     * getCurrent return bootstrap base width interval name
     *  @public method
     * @return {string} - bootstrap base width interval name
     */
    Resolutions.prototype.getCurrent = function () {
        logger.info('Resolution = > getCurrent');
        return this._getDeviceType();
    };
    return Resolutions;
}());
export { Resolutions };
export default Resolutions;
